/**
 * Shape helpers for the authoring annotation state that still lives in index.js.
 * Later phases can move the mutable owner here without changing the export schema.
 */
export function createAuthoringState(overrides = {}) {
  const state = {
    highlightBands: [],
    storySnippets: [],
    auditLog: [],
    layers: [],
    activeLayerId: '',
    ...overrides,
  }
  return {
    ...state,
    highlightBands: Array.isArray(state.highlightBands)
      ? state.highlightBands
      : [],
    storySnippets: Array.isArray(state.storySnippets)
      ? state.storySnippets
      : [],
    auditLog: Array.isArray(state.auditLog) ? state.auditLog : [],
    layers: Array.isArray(state.layers) ? state.layers : [],
  }
}
